import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ScannerActions } from '../../state/scanner/scanner.actions';

import { MatListItem } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import {
  MatExpansionPanel,
  MatExpansionPanelActionRow,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';

@Component({
  selector: 'eca-scan-progress-list-item',
  templateUrl: './scan-progress-list-item.component.html',
  styleUrls: ['./scan-progress-list-item.component.scss'],
  imports: [MatListItem, MatProgressSpinner, MatIcon, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatExpansionPanelActionRow, MatButton, ThrottleClickDirective]
})
export class ScanProgressListItemComponent {
  private store = inject<Store<any>>(Store);


  @Input() icon: string;
  @Input() show: boolean;
  @Input() completeIcon: string;

  @Input() text: string;
  @Input() details: string;
  @Input() actions: Array<{ label: string, dispatch: string }>;
  @Input() completed: boolean;
  @Input() failed: boolean;

  dispatch(action: string) {
    this.store.dispatch({ type: ScannerActions[action] });
  }

}
